"use client";
import S3Image from "@/components/S3Image";
import { useTranslation } from "@/hooks/translationContext";
import { useSite } from "@/lib/hooks/site";

export default function AddPlaceScroll() {
  const { descriptions, domain } = useSite();
  const {t} = useTranslation();

  const getDomain = () => {
    const split = domain.split(".");
    return split[split.length - 1];
  };

  return (
    <div className="py-3 container flex flex-row items-center gap-4 md:gap-14 w-full">
      <div className="w-10 p-2 bg-white rounded-full shadow">
        <S3Image
          loader={({ src }) => src}
          sizes="24w"
          width={24}
          height={24}
          className="w-6 h-6"
          unoptimized
          src="/scroll-down.webp"
          alt={`scroll down`}
        />
      </div>

      <h2 className="text-assistant font-bold text-2xl md:text-[28px] max-w-[306px] md:max-w-[440px]">
        {t("add-venue-page-second-section-title", {
          defaultValue: `${descriptions[0]?.title}.${getDomain()} üyelik paketi almanın 4 avantajı`
        })}
      </h2>
    </div>
  );
}
